import React from 'react'
import Overview from '../../Components/Dashboard/Overview'
import NewUsers from '../../Components/Dashboard/NewUsers'

function MainDashboard() {
  return (
    <div>
      <Overview/>
      <NewUsers />
    </div>
  )
}

export default MainDashboard